export default __webpack_public_path__ + "static/issue_text_codebook-d09b57bff73006ca91a2343a02205e6e.pdf";